<template lang="pug">
  Header(fixed)
    SidebarToggler.d-lg-none(display="md" mobile)
    SidebarToggler.d-md-down-none(display="lg")
    b-navbar-brand(:to="defaultLink").justify-content-start
      span.navbar-brand-full {{ $t("message.app.full") }}
      span.navbar-brand-minimized {{ $t("message.app.minimized") }}
    b-navbar-nav.ml-auto
      //- NavbarLanguage.d-lg-none
      Alert(:alert="isPendingTix" :randomKey="randomKey" v-if="showNotification && isPendingTix && $store.getters.alertOn == true").mx-2
      a.fas.fa-bell.fa-lg.text-info(href="javascript:void(0)" @click="toTicketPage" v-if="showNotification").mr-1
      span.badge.badge-pill.badge-info(:class="{ 'blink': depTotalRow > 0 || wdwTotalRow > 0}" v-if="showNotification") {{ depTotalRow + wdwTotalRow }}
      AsideToggler.aside.d-md-down-none(display="lg")
    vue-snotify
</template>

<script>
import { Header, SidebarToggler, AsideToggler } from "@/library/coreui";
import NavbarLanguage from "@/library/NavbarLanguage";
import Alert from '@/library/Alert';
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  components: {
    Header,
    SidebarToggler,
    NavbarLanguage,
    AsideToggler,
    Alert
  },
  data: () => ({
    timerId: null,
    refreshTime: 5,
    refreshUpdate: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pendingTicket: false,
    depTotalRow: 0,
    wdwTotalRow: 0,
    alertKey: '',
    operatorDetail: null,
    subDetail: null,
  }),
  computed: {
    defaultLink() {
      if (this.$store.getters.account[0] && this.$store.getters.authorityRole) {
        if (this.$store.getters.authorityRole != 'SUB_PRI') {
          if (this.$store.getters.account[0].account_type == 3)
            return '/account/operator';
          else if (this.$store.getters.account[0].account_type == 2)
            return '/account/member';
        } else
          return '/system/setting';
      }

      return '/system/dashboard';
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    randomKey() {
      return this.alertKey;
    },
    isPendingTix() {
      return this.pendingTicket;
    },
    getAccountType() {
      if (this.$store.getters.account[0])
        return this.$store.getters.account[0].account_type;

      return 0;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    getSelfOperate() {
      // if (this.$store.getters.account[0])
      //   return this.$store.getters.account[0].self_operate;
      if (this.operatorDetail)
        return this.operatorDetail.self_operate;

      return false;
    },
    showNotification() {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.subDetail && this.subDetail.authority_option) {
          if (this.subDetail.authority_option.includes('ticket') && this.getSelfOperate == true)
            return true;
          else
            return false;
        } else
          return false;
      } else {
        if (this.getAccountType == 2 && this.getSelfOperate == false)
          return false;
        else
          return true;
      }
    }
  },
  created: function() {
    this.$options.refreshEnabled = true;
  },
  mounted: function() {
    this.getInfo();
    this.startCountDownRefresh();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    getInfo() {
      if (this.getAuthorityRole == 'SUB_PRI') {
        this.getSubDetail();
        this.getAgentDetail();
      }
      else
        if (this.getAccountType == 2)
          this.getAgentDetail();
    },
    getAgentDetail() {
      let url = config.accountAgentDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.account[0].account_type == 2 ? this.$store.getters.account[0].parent_id : this.$store.getters.accountId,
        target_account_id: this.$store.getters.accountId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getSubDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sub_login_id: this.$store.getters.loginId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    forceRerenderAlert: function() {
      this.alertKey = Math.random().toString(36).replace('0.', '');
    },
    toTicketPage: function() {
      this.$router.push("/ticket");
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        //this.getInfo();
        this.getTicketList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();

          if (this.showNotification == true) {
            if (this.depTotalRow > 0 || this.wdwTotalRow > 0) {
              this.pendingTicket = true;
              this.forceRerenderAlert();
            } else {
              this.pendingTicket = false;
            }
          }
        }, this.refreshTime * 1000);
      }
    },
    getTicketList: function() {
      if (this.showNotification == true) {
        this.getDepositList(true);
        this.getWithdrawalList(true);
      } else {
        this.depTotalRow = 0;
        this.wdwTotalRow = 0;
        this.pendingTicket = false;
      }
    },
    getDepositList: function() {
      let url = config.ticketListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_status: 0,
        request_type: 'DEPOSIT',
        start_date: this.$moment(new Date).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date).format('YYYY-MM-DD'),
        sort_type: "desc",
        page_number: 1,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalList: function() {
      let url = config.ticketListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_status: 0,
        request_type: 'WITHDRAWAL',
        start_date: this.$moment(new Date).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date).format('YYYY-MM-DD'),
        sort_type: "desc",
        page_number: 1,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.wdwTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
  }
};
</script>
<style lang="scss">
.badge {
  padding: 2.5px 4px !important;
}
.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

@keyframes blinking {
  0% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
  50% {
    background-color: rgb(211, 98, 143);
    color: #ffffff;
  }
  100% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
}
</style>
